import { WorldpayCustomisationBorder } from './worldpay-customisation-border.interface';

export interface WorldpayCustomisationInteraction {
  backgroundColor?: string;
  border?: WorldpayCustomisationBorder;
  color?: string;
  fonts?: string[];
}
